import React, { useState, useEffect } from "react";
import { Container } from "react-grid-system";

import { FormContainer, Card, Title, Paragraph, ContainerForm, RowInfo, ColInfo, Label, Texto } from "./styles";

import FormLocalAplicacao from "./form";

import location from '../../../assets/icons/icon-location.svg'
import ArrowIcon from "../../../assets/icons/icon-arrow-down.svg";
import ArrowIconDisabled from "../../../assets/icons/icon-arrow-disabled.svg";

import * as S from "./styles";
import { theme } from "../../../styles/theme";
import { BodyP, BodyPSpan, H6, TaglineP, TaglinePSpan } from "../../../styles/stylesTypography";


const PrescriptionStepTwo = ({ ...props }) => {

    const [isOpenBox, setIsOpenBox] = useState(false);
    const [erroProd, setErroProd] = useState(false);
    const [erroFarm, setErroFarm] = useState(false);
    const [erroDevolution, setErroDevolution] = useState(false);

    const openBoxProdutor = () => {
        setIsOpenBox(!isOpenBox);
    }

    const openBoxProdutor2 = () => {
        if ((isOpenBox === false || isOpenBox === undefined) && props.disabled === false) {
            setIsOpenBox(!isOpenBox);
        }
    }

    const updateValues = (values) => {
        props.update(values);
    }

    useEffect(() => {
        props.updateIsOpen(isOpenBox);

        if (isOpenBox === false) {
            if (props.existInformation) {
                if (props.params.produtor || props.params.fazenda || props.params.devolucao) {
                    if (props.params.produtor.label === '' || props.params.produtor === "") {
                        setErroProd(true);
                        props.updateError(true);
                    } else {
                        setErroProd(false);
                    }

                    if (props.params.fazenda === '') {
                        setErroFarm(true);
                        props.updateError(true);
                    } else {
                        setErroFarm(false);
                    }

                    // if (props.params.devolucao === '') {
                    //     setErroDevolution(true);
                    //     props.updateError(true);
                    // } else {
                    //     setErroDevolution(false);
                    // }
                }
            }
        }
    },[isOpenBox])

    useEffect(() => {
        if (props.isOpen != isOpenBox) {
            setIsOpenBox(props.isOpen);
        }
    },[props.isOpen])

    return (
        <Container>
            <FormContainer>
                <Card className="step03" existInformation={props.existInformation} onClick={() => openBoxProdutor2()} openBox={isOpenBox} disabled={props.disabled} erro={erroProd === true || erroFarm === true || erroDevolution === true ? true : props.error}>
                    <div className="row">
                        <H6 color={props.disabled ? theme.colors.disabled.Desabilitado_Medio : theme.colors.gray.Cinza_2}>
                            Local de aplicação
                        </H6>

                        {!props.disabled ? (
                            <img className="arrow" src={ArrowIcon} alt='arrow' onClick={() => openBoxProdutor()}/>
                        ) : (
                            <img className="arrow" src={ArrowIcon} alt='arrow'/>   
                        )}
                    </div>
                    
                    {!props.existInformation ? (
                        <>
                            {!isOpenBox ? (
                                <Paragraph disabled={props.disabled}>Infome o Produtor, o Local de aplicação e o Local de devolução.</Paragraph>
                            ) : (
                                <ContainerForm>
                                    <FormLocalAplicacao 
                                        estado={props.estado}
                                        responsavel={props.responsavel}
                                        art={props.art}
                                        crea={props.crea}
                                        update={(value) => updateValues(value)}
                                        params={props.params}
                                        recipeDraft={props.recipeDraft}
                                    />
                                </ContainerForm>
                            )}
                        </>
                    ) : (
                        <>
                            {!isOpenBox ? (
                                <RowInfo>
                                    <ColInfo>
                                        <TaglineP color={
                                            props.disabled ? theme.colors.disabled.Desabilitado_Medio : 
                                            erroProd === true ? theme.colors.red.Vermelho_erro : 
                                            props.params.erroProdutor ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_2}
                                        >
                                            Produtor
                                        </TaglineP>

                                        {erroProd === false && props.params.erroProdutor === false ? (
                                            <S.ContainerInfoText 
                                                bgColor={theme.colors.blue.Azul_link}
                                                erro={erroProd === true ? erroProd : props.params.erroProdutor} 
                                                disabled={props.disabled}
                                            >
                                                <TaglinePSpan color={theme.colors.white.Branco}>
                                                    {props.params.produtor?.label?.split(' - CPF/CNPJ:')[0] || ''}
                                                </TaglinePSpan>
                                            </S.ContainerInfoText>
                                        ) : ("")}
                                        
                                    </ColInfo>

                                    <ColInfo>
                                        <TaglineP color={
                                            props.disabled ? theme.colors.disabled.Desabilitado_Medio : 
                                            erroFarm === true ? theme.colors.red.Vermelho_erro : 
                                            props.params.erroFazenda ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_2}
                                        >
                                            Propriedade Rural
                                        </TaglineP>

                                        {erroFarm === false && props.params.erroFazenda === false ? (
                                            <S.ContainerInfoText 
                                                bgColor={theme.colors.gray.Cinza_12}
                                                erro={erroFarm === true ? erroFarm : props.params.erroFazenda} 
                                                disabled={props.disabled}
                                            >
                                                <img src={location} alt='location'/>
                                                
                                                <TaglinePSpan color={
                                                    erroFarm === true ? theme.colors.red.Vermelho_erro : 
                                                    props.params.erroFazenda ? theme.colors.red.Vermelho_erro : theme.colors.blue.Azul_link}
                                                >
                                                    {props.params.fazenda?.label || ''}
                                                </TaglinePSpan>
                                            </S.ContainerInfoText>
                                        ) : ("")}
                                    </ColInfo>
                                    
                                    <ColInfo>
                                        <TaglineP color={
                                            props.disabled ? theme.colors.disabled.Desabilitado_Medio : 
                                            erroDevolution === true ? theme.colors.red.Vermelho_erro : 
                                            props.params.erroProdutor ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_2}
                                            >
                                            Local de devolução
                                        </TaglineP>

                                        <BodyPSpan color={
                                            erroDevolution === true ? theme.colors.red.Vermelho_erro : 
                                            props.params.erroDevolucao ? theme.colors.red.Vermelho_erro : theme.colors.gray.Cinza_2}
                                            >
                                            {props.params.devolucao?.label || ''}
                                        </BodyPSpan>
                                    </ColInfo>
                                </RowInfo>
                            ) : (
                                <ContainerForm>
                                    <FormLocalAplicacao 
                                        estado={props.estado}
                                        responsavel={props.responsavel}
                                        art={props.art}
                                        crea={props.crea}
                                        update={(value) => updateValues(value)}
                                        params={props.params}
                                        recipeDraft={props.recipeDraft}
                                    />
                                </ContainerForm>
                            )}
                        </>
                    )}
                </Card>
            </FormContainer>
        </Container>
    )
};

export default PrescriptionStepTwo;